export const theme = {
	// primary: '#373275',
	// primaryLight: '#9d98d3',
	primary: '#000000',
	primaryLight: '#E5E5E5',
	assignedLight: '#dbffdb',
	black: '#000000',
	white: '#ffffff',
}
